module.exports = __webpack_public_path__ + "img/5d691b2.jpg";